import React from 'react';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import {cargarCatalogosGenericoAsync, cargarCatalogos_Otros } from '../../funciones_globales/catalogos';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { formatearFecha } from '../../funciones_globales/format';
import '../componentes_generales/componentes_formulario/contenedores/flexbox.css'
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { completar_String } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';

const ContainerEdit = styled.div`    
    border-bottom: 1px solid #cfd8dc;
    height: 50px;  
    padding: 10px;
    margin-bottom: 4px;
`;

const InputText2 = styled.input`
    height: 27px;
    padding: 5px 10px;
    font-size: 11px;
    line-height: 1.5;
    border-radius: 3px;
    
    width: 50%;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
`;

class FormComp03 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Estados formulario
            operacion: 'G',
            permiso: 'M',
            ult_transaccion: null,
            cod_proveedor:  null,
            planVigente: null,

            fechaProceso: null,
            fecha_nc: null,
            
            valor: 0,
            observaciones: "",
            num_doc: "",
            compra: "----------",
            saldo: 0,
            num_doc_serieNC: "",
            num_docNC: "",
            notaCredito: "",
            autorizacion:"",

            //VALORES PARA UPDATE
            valorAnterior: 0,
            compraAnterior: null,
            CompraApliAnt: null,

            iva: 0,
            total: 0,

            opt_concepto: [],
            concepto_sel: null,

            opt_tipoCompra: [],
            tipoCompra_sel: null,

            opt_docsCargados: [],
            docsCargados_sel: null,

            //DOCUMENTOS PENDIENTES (ONLY)
            opt_docPendientes: [],
            docPendientes_sel: null,

            //Catalogos
            opt_ope_NC: [{value: 'NC', label: 'SRI'},{value: 'CA', label: 'Interna'}],
            ope_NC_sel: 'CA',

            //CONTROL DE ASGINACION DOCS
            controlAsignacion: false,
            compraAsignada: "",
            saldoAsignado: 0,
            counterMsj: 0,

            //CONTROL CA
            saldoSuperiorCA: false,
            counterMsjCA: 0,

            //CONTROL CARGA
            carga: false, //MEAN WHILE TRUE, THE PAGE IS LOADING...
            labelAplicado: null, //VALOR A APLICAR EN EL DOC
            valorApliTributario: null,

            valorApliTribO: null,
            valorApliO: null,

            //Catalogos de Cuentas por Rubros
            catalogoCuentasPorRubro: [],
            cuentaLabel: '',
            descripcionLabel: '',
        };

        this.changeValueGeneral = this.changeValueGeneral.bind(this);
        this.validNumSerieNC = this.validNumSerieNC.bind(this);
        this.changeNumSerie = this.changeNumSerie.bind(this);
        this.changeNumFactura = this.changeNumFactura.bind(this);
        this.changeNotaCredito = this.changeNotaCredito.bind(this);
        this.setOperacion = this.setOperacion.bind(this);
        this.validacionValor = this.validacionValor.bind(this);
        this.getNotaCredito = this.getNotaCredito.bind(this);
        this.clear = this.clear.bind(this);

        this.guardarCredito = this.guardarCredito.bind(this);
        this.anularCredito = this.anularCredito.bind(this);
        this.totalizar = this.totalizar.bind(this);

        this.getProveedor = this.getProveedor.bind(this);
        this.selCompra = this.selCompra.bind(this);
        this.selCompraAsignada = this.selCompraAsignada.bind(this);
        this.changeProveedor = this.changeProveedor.bind(this);
    }   

    changeValueGeneral(event){    
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({            
        [name]: value
        });

        if((name==='valor'||name==='iva') && this.state.ope_NC_sel==='CA'){
            this.setState({counterMsjCA: 0})
        }
        
       
    }

    //Funcion para cargar movimientos a la pantalla
    getNotaCredito(){
        if(this.state.notaCredito === ''){
            alert("Digite un movimiento");
        }else if(parseInt(this.state.notaCredito,10) <= 0 ){
            alert("Movimiento no válido");
            this.clear();
        }else{
            global_axios({
                method: 'GET',
                url: '/creditoproveedores/'+this.state.notaCredito.toString()
            })
            .then((response)=>{
                if(response){

                }

                this.setState({carga: true}, ()=>{
                    //Store de respuesta
                    var NC = response.data[0];
                    
                    //Almacena el Proveedor key
                    var itemProv = {}
                    console.log("NC LOAD: ", NC)

                    //CARGA PROVEEDOR
                    if(NC.Prov===null){
                        itemProv = null;
                    }else{
                        itemProv.value = NC.Prov.Codigo;
                        itemProv.label = NC.Prov.Descripcion
                    }

                    //ASIGNA COMPRA APLICADA ANT:
                    this.setState({CompraApliAnt: NC.CompraAplicada})

                    //Asignacion de datos de cabecera
                    this.setState({
                        //OPERACION
                        ope_NC_sel: NC.Operacion===null?"":NC.Operacion,
                        //Proveedor
                        cod_proveedor: itemProv,
                        //TipoDoc 
                        tipoCompra_sel: NC.TipoDoc===null?"":NC.TipoDoc
                    })
                    //LLENA LOS COMBOS DE DOCUMENTOS
                    this.cargarObjetos('/compras?proveedor='+itemProv.value+'&tipo='+NC.TipoDoc+'&status=P&status=E').then((result_docs)=>{  
                        console.log("RESULT DOCS: ",result_docs)
                        var arrayDocs = [], docsProcesados = [];
                        arrayDocs = result_docs;
                        let arrayPendiente = [];
                        if(arrayDocs.length>0){
                            
                            arrayDocs.forEach((DATA)=>{
                                let item = {};
                                let str = "";
                                str = DATA.Establecimiento.toString().trim()+''+DATA.PuntoVenta.toString().trim()+'-'+DATA.Factura.toString().trim()
                                item.value = DATA.Compra
                                item.label = str
                                item.Saldo = DATA.Saldo;
                                item.Importe = DATA.Importe;
                                item.Compra = DATA.Compra;

                                //ArrayDocsPendientes+Cancelados
                                docsProcesados.push(item);
                                
                                //ArrayDocsPendientes
                                arrayPendiente.push(item);
                            })

                        }else{
                            alert("El proveedor no tiene documentos pendientes")
                        }
                            
                        //guarda solo docs pendientes en state provisional
                        this.setState({opt_docPendientes: arrayPendiente }, ()=>{
                            if(NC.Operacion==='NC'){
                                //TRAE TOP 5 DE DOCS CANCELADOS
                                this.cargarObjetos('/compras?proveedor='+itemProv.value+'&tipo='+NC.TipoDoc+'&status=C&top=5&order=DESC').then((resultC)=>{
                                    if(resultC.length >0){
    
                                        //INSERT DE SEPARADOR EN REACTSELECT
                                        let itemS = {};
                                        itemS.label = "= CANCELADAS =";
                                        itemS.value = '===';
                                        itemS.disabled=true;
                                        docsProcesados.push(itemS);
    
                                        resultC.forEach((CANCEL)=>{
                                            let item = {};
                                            let str = "";
                                            str = CANCEL.Establecimiento.toString().trim()+''+CANCEL.PuntoVenta.toString().trim()+'-'+CANCEL.Factura.toString().trim()
                                            item.value = CANCEL.Compra
                                            item.label = str
                                            item.Saldo = CANCEL.Saldo;
                                            item.Importe = CANCEL.Importe;
                                            item.Compra = CANCEL.Compra;
    
                                            docsProcesados.push(item);
                                        })
                                    } 
                                    this.setState({opt_docsCargados: docsProcesados}, ()=>{
                                        let found = false;
                                        //BUSCA EL DOC PARA SELECCIONARLO O INSERTARLO
                                        this.state.opt_docsCargados.forEach((DOCS)=>{
                                            if(DOCS.Compra === NC.Compra){
                                                found = true;
                                            }
                                        })
                                        if(found===true){
                                            //FUNCION PARA SELECCIONAR DOC
                                            this.selectDocsCargados(NC);
                                        }else{
                                            //NO ENCONTRO DOC BUSCA E INSERTA
                                            console.log("ENTRO A EXTRA QUERY POR DOC CARGADO")
                                            //CARGA EL MOVIMIENTO GUARDADO
                                            this.cargarObjetos('/compras?proveedor='+itemProv.value+'&tipo='+NC.TipoDoc+'&compra='+NC.Compra).then((resultCmpLoad)=>{
                                                
                                                let  DOC = resultCmpLoad[0];
                                                console.log("COMPRA LOAD: ", resultCmpLoad)

                                                let item = {};
                                                let str = "";
                                                str = DOC.Establecimiento.toString().trim()+''+DOC.PuntoVenta.toString().trim()+'-'+DOC.Factura.toString().trim()
                                                item.value = DOC.Compra
                                                item.label = str
                                                item.Saldo = DOC.Saldo;
                                                item.Importe = DOC.Importe;
                                                item.Compra = DOC.Compra;
        
                                                docsProcesados.push(item);

                                                //AHORA BUSCA SOBRE EL CATALOGO CON EL REGISTRO INSERTADO SELECCIONA
                                                this.setState({opt_docsCargados: docsProcesados}, ()=>{
                                                    this.selectDocsCargados(NC);
                                                })
                                            })
                                        }
                                    })
                                })
                            }
                        })
                    })
                    .then(()=>{
                        //SELECCION DEL CATALOGO CON EL VALOR TRAIDO DE DOCS PENDIENTES
                        if(NC.compraApli!==null){
                            let seriePendiente = `${NC.compraApli.Establecimiento}${NC.compraApli.PuntoVenta}-${NC.compraApli.Factura}`
                            
                            let found = false;
                            if(this.state.opt_docPendientes.length > 0){
                                this.state.opt_docPendientes.forEach((PEN)=>{
                                    if(PEN.label === seriePendiente){
                                        found = true;
                                        this.setState({docPendientes_sel: PEN},()=>{
                                            this.selCompraAsignada();
                                        });
                                    }
                                })
                            }

                            if(found===false){
                                console.log("EXTRA QUERY POR DOC APL NO ENCONTRADO EN EL CATALOGO")
                                this.cargarObjetos('/compras?proveedor='+itemProv.value+'&tipo='+NC.TipoDoc+'&compra='+NC.CompraAplicada).then((resCompApl)=>{
                                    let APL = resCompApl[0]; //arrayPendiente
                                    let arrayPendiente = this.state.opt_docPendientes;

                                    let item = {};
                                    let str = "";
                                    str = APL.Establecimiento.toString().trim()+''+APL.PuntoVenta.toString().trim()+'-'+APL.Factura.toString().trim()
                                    item.value = APL.Compra
                                    item.label = str
                                    item.Saldo = APL.Saldo;
                                    item.Importe = APL.Importe;
                                    item.Compra = APL.Compra;

                                    arrayPendiente.push(item);

                                    this.setState({opt_docPendientes: arrayPendiente }, ()=>{
                                        this.state.opt_docPendientes.forEach((PEN)=>{
                                            if(PEN.label === seriePendiente){
                                                found = true;
                                                this.setState({docPendientes_sel: PEN},()=>{
                                                    this.selCompraAsignada();
                                                });
                                            }
                                        })
                                    })
                                })
                            }
                        }
                    })

                    this.setState({num_doc: NC.Factura===null?"":NC.Factura})

                    this.setState({concepto_sel: NC.Tipo===null?"":NC.Tipo})

                    this.setState({valor: NC.Valor===null?"":NC.Valor})
                    this.setState({iva: NC.Iva===null?"":NC.Iva})
                    this.setState({autorizacion: NC.Iva===null?"":NC.Autorizacion})
                    
                    var valor = NC.Valor===null?0:NC.Valor
                    var iva = NC.Iva===null?0:NC.Iva
                    
                    this.setState({total: Math.round((valor + iva)* 100)/ 100}, ()=>{
                        //Abrir el panel de asignacion
                        if(NC.Operacion==='NC'){
                            let saldo = this.state.saldo
                            console.log("SALDO A COMPRARA: ",saldo)
                            if(this.state.total > saldo && NC.ValorAplicado!==null){
                                this.setState({controlAsignacion: true})
                            }
                        }
                    })
                    //VALOR QUE SE ENVIARAN EN EL UPDATE
                    this.setState({valorAnterior: Math.round((valor + iva)* 100 )/ 100, compraAnterior: NC.Compra!==null?NC.Compra:null,
                        labelAplicado: NC.ValorAplicado!==null?NC.ValorAplicado:null},()=>{
                            //GUARDADO DEL SALDO ANTERIOR APLICADO
                            this.setState({valorApliTribO: NC.valorAplicadoTributario!==null?NC.valorAplicadoTributario:null,
                                valorApliO: NC.ValorAplicado!==null?NC.ValorAplicado:null}) //this.state.valorAnterior-this.state.labelAplicado
                            
                        })
                    
                    this.setState({observaciones: NC.Observacion===null?"":NC.Observacion})

                    if(NC.FechaNC){                        
                        var fechaNC = new Date(NC.FechaNC).toISOString().substring(0,10)
                        fechaNC = formatearFecha(fechaNC, 'DD/MM/YYYY')
                        this.setState({fecha_nc: moment(fechaNC,'DD/MM/YYYY')})
                    }else{  
                        this.setState({fecha_nc: moment()})
                    }

                    if(NC.Fecha){
                        var fechaProceso = new Date(NC.Fecha).toISOString().substring(0,10)
                        this.setState({fechaProceso: moment(formatearFecha(fechaProceso), 'DD/MM/YYYY')})
                    }else{
                        this.setState({fechaProceso: moment()})
                    }

                    this.setState({num_doc_serieNC: NC.SerieNC===null?"":NC.SerieNC})
                    this.setState({num_docNC: NC.ConsecutivoNC===null?"":NC.ConsecutivoNC.toString().trim()})

                    if(NC.compra!==null){
                        this.setState({compra: NC.Compra, saldo: NC.compra.Saldo})
                    }

                    this.setState({operacion: 'M', carga: false});
                })
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);      
            });

        }
    }

    //Carga seleccion de documentos
    selectDocsCargados(NC){
        if(this.state.opt_docsCargados.length >0){
            let item = {};
            item.label = `${NC.Establecimiento}${NC.PuntoVenta}-${NC.Factura}`
            console.log("CARGA DE COMBO: ", item)
            console.log("DOCSCARGADOS: ",this.state.opt_docsCargados)
            this.state.opt_docsCargados.forEach((CAR)=>{
                if(CAR.label === item.label){
                    this.setState({docsCargados_sel: {...CAR, SaldoAplicado: (NC.Valor+NC.Iva)-NC.ValorAplicado}});
                }
            })
            this.ActivaDesactivaListaDocs(this.state.opt_docPendientes, item, true)
        }
    }

    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{                
                reject('Compra no existe o esta anulada...');
            });
        });
    }

    changeNotaCredito(event){
        const target = event.target;    
        const value = target.value;
        this.setState({notaCredito: value},()=>{
            this.clear();
            if(value===""){
                this.setState({operacion: "G"})
            }
        });
    }

    setOperacion(){
        var value;
        value = this.state.notaCredito

        if(value === ""){
            this.setState({operacion: 'G'});
        }else{
            this.setState({operacion: 'M'});
        }
    }

    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    validacionValor(){
        var valor = parseFloat(this.state.valor)
        if(Number.isNaN(valor)===true){
            this.setState({valor: 0}, ()=>{
                this.totalizar();
            })
        }else{
            this.totalizar();
        }
    }

    //Totaliza valores despues del lost focus de TXT IVA
    totalizar(){
        var valor = 0;
        var iva = 0;
    
        valor = parseFloat(this.state.valor)
        console.log("VERIFIED: ",Number.isNaN(this.state.iva))
        if(Number.isNaN(this.state.iva)===true){
            iva = 0;
        }else{
            iva = Number.isNaN(parseFloat(this.state.iva))?0:parseFloat(this.state.iva);
            this.setState({iva: iva});
        }
        this.setState({total: Math.round((valor + iva) * 100)/ 100}, ()=>{
            if(parseFloat(this.state.total)>parseFloat(this.state.saldo) /*&& this.state.operacion==='G'*/ && this.state.ope_NC_sel==='NC'){
                console.log("CONTROL ASIGNACION: ",parseFloat(this.state.total)+'  '+parseFloat(this.state.saldo) )
                //PRESERVA INTERACCION ORIGINAL
                //if(this.state.operacion==='M' && this.state.compra !== this.state.compraAnterior){
                    this.setState({controlAsignacion: true});
                //}

                //FUNCIONAMIENTO NORMAL
                // if(this.state.oepracion==='G'){
                //     this.setState({controlAsignacion: true});
                // }
                
            }else if(parseFloat(this.state.total)<=parseFloat(this.state.saldo) && this.state.ope_NC_sel==='NC'){
                //this.setState({controlAsignacion: false});
                //PRESERVA INTERACCION ORIGINAL
                //if(this.state.operacion==='M' && this.state.compra !== this.state.compraAnterior){
                    this.setState({controlAsignacion: false});
                //}
                //FUNCIONAMIENTO NORMAL
                // if(this.state.oepracion==='G'){
                //     this.setState({controlAsignacion: true});
                // }
            }

            //Mesaje cuando a excedido el valor de la compra original}
            if(parseFloat(this.state.total)>parseFloat(this.state.saldo) /*&& this.state.operacion==='G'*/ && this.state.ope_NC_sel==='CA'){
                this.setState({saldoSuperiorCA: true})
                // let saldo = parseFloat(this.state.total)-parseFloat(this.state.saldo)
                // alert(`El monto del crédito es superior al saldo de la compra: ${this.state.compra} con ${Math.round(saldo*100)/100}`)
            }else if(parseFloat(this.state.total)<=parseFloat(this.state.saldo) /*&& this.state.operacion==='G'*/ && this.state.ope_NC_sel==='CA'){
                this.setState({saldoSuperiorCA: false})
            }
        })
    }

    guardarCredito(){
        var errors = "";
        var proceder = true;

        //FECHA DE PROCESO POR MODULO
        let fechaProceso = getFechaProcesoPorModulo('06');

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        // Validacion de fecha de proceso que se puede cambiar ------------------------------
        if (this.props.permiteCambioFProceso==='S'){
            let resultadoValidFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProceso, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
            if(resultadoValidFProceso.esValida===false){
                proceder = false;
                errors = errors + resultadoValidFProceso.msg+'\n'
                console.log("PROCESO FECHA PROCESO: ", resultadoValidFProceso)
            }
        }

        //Llenar todos los campos obligatorios
        if(this.state.ope_NC_sel===null || this.state.cod_proveedor===null || this.state.concepto_sel===null || this.state.docsCargados_sel === null || this.state.observaciones === ""
            || this.state.tipoCompra_sel===null || this.state.valor === 0){
            proceder = false;
            errors = errors +"- Debe llenar todos los campos en pantalla\n";
        }

        //Validacion para pagar la factura completamente CASO CA
        //if((Math.round(parseFloat(this.state.saldo)* 100)/ 100) !== (Math.round(parseFloat(this.state.total)* 100)/ 100) && this.state.ope_NC_sel==="CA"){
        //    proceder = false;
         //   errors = errors +"- El total "+this.state.total+" debe ser igual al saldo "+Math.round(this.state.saldo*100)/100+"\n";
       // }

        //valida por el ingreso de la NC CASO NC
        if(this.state.ope_NC_sel==="NC" && (this.state.num_doc_serieNC==="" || this.state.num_docNC==="")){
            proceder = false;
            errors = errors +"- Ingrese la serie y el consecutivo de la NC emitida por el proveedor\n";
        }

         //valida por el Autorizacion
         if(this.state.ope_NC_sel==="NC" && (this.state.autorizacion==="")){
            proceder = false;
            errors = errors +"- Ingrese el número de autorizacion de la NC emitida por el proveedor\n";
        }

        //Valida por fecha ingresada en caso NC
        if(this.state.ope_NC_sel==="NC" && !this.state.fecha_nc){
            proceder = false;
            errors = errors +"- Ingrese una fecha para la NC\n";
            
        }else if(this.state.ope_NC_sel==="NC" && this.state.fecha_nc){
            let fecha_nc = formatearFechaMoment_a_String(this.state.fecha_nc);
            let resultado = validarFechaMomentEnFormatoString(fecha_nc);

            if(resultado === false){
                proceder = false;
                errors = errors +"- Ingrese una fecha para la NC en formato correcto\n";
            }
        }

        //Pregunta por CASO 'NC' no asignar factura
        if(this.state.ope_NC_sel==='NC' && this.state.docPendientes_sel===null && this.state.controlAsignacion===true){
            let msjConfirm = window.confirm("No está asignando el crédito a ningún documento con saldo,\nEl crédito se guardará para aplicarlo sobre una compra del proveedor. ¿Desea continar?")
            if(!msjConfirm){
                proceder = false;
                errors = errors +"- Operación cancelada por el usuario\n";
            }
        }

        //PREGUNTA SI EL SALDO DEL DOC ASIGNADO ES MAYOR AL SALDO DEL DOC ASIGNADO
        if(this.state.controlAsignacion===true && this.state.docPendientes_sel !==null && this.state.operacion==='G'){/* * */
            let valorApliCompS = this.mostrarAsignacion();
            if(valorApliCompS > Math.round(this.state.saldoAsignado*100)/100){
                proceder = false;
                errors = errors +"- El valor aplicado es mayor al saldo del documento seleccionado\n";
            }
        }

        if(proceder === true){ 

            var data = {};
            data.localidad = '01';
            data.Tipo = this.state.concepto_sel;
            data.Compra = this.state.compra;
            data.Proveedor = this.state.cod_proveedor.value;
            data.Fecha = formatearFechaMoment_a_String(this.state.fechaProceso);
            data.Valor = parseFloat(this.state.valor)
            data.Iva = parseFloat(this.state.iva)
            data.Moneda = JSON.parse(getItemDatosSesion('moneda')).Moneda;
            data.Dolar = JSON.parse(getItemDatosSesion('moneda')).Cotizacion;
            data.Observacion = this.state.observaciones.toString().trim().toUpperCase();
            data.Usuario = getItemDatosSesion('usuario');
            data.Status = 'P';
            data.TipoDoc = this.state.tipoCompra_sel;
            data.FechaSistema = getItemDatosSesion('fechasistema');
            data.Operacion = this.state.ope_NC_sel;
            data.Total = parseFloat(this.state.total);
            data.IdRegAudit = this.props.IdRegAudit;
            data.controlAsignacion = this.state.controlAsignacion

            //NC ONLY
            if(this.state.ope_NC_sel==='NC'){
                data.SerieNC = this.state.num_doc_serieNC.toString().trim();
                data.ConsecutivoNC = this.state.num_docNC.toString().trim();
                data.FechaNC = formatearFechaMoment_a_String(this.state.fecha_nc);
                data.autorizacion =this.state.autorizacion.toString().trim();

                if(this.state.controlAsignacion===true && this.state.operacion==='G'){
                    let valAplicado = Math.round((this.state.total-this.state.saldo)*100)/100;
                    data.ValorAplicado = this.state.controlAsignacion===true?valAplicado:null;// SOLO USADO PARA CREATE
                }else if(this.state.operacion==='M'){
                    data.ValorAplicado = this.state.controlAsignacion===true?Math.round(this.mostrarAsignacion()*100)/100:null;
                    console.log("COMPRA APLI ANT: ",this.state.CompraApliAnt)
                    console.log("COMPRA APLI: ",this.state.CompraAplicada)

                    if(this.state.docPendientes_sel!==null){
                        data.CompraApliAnt =  this.state.CompraApliAnt===this.state.docPendientes_sel.Compra?null:this.state.CompraApliAnt
                    }else{
                        data.CompraApliAnt = this.state.CompraApliAnt!==null?this.state.CompraApliAnt:null;
                    }
                    
                }
            }
            
            //Adición asignación segundo documento
            data.Establecimiento = this.state.docsCargados_sel.label.toString().substring(0,3);
            data.PuntoVenta = this.state.docsCargados_sel.label.toString().substring(3,6);
            let fac = this.state.docsCargados_sel.label.toString().split("-");
            data.Factura = fac[1];

            //SE ENVIAN SOLO POR MODIFICACIÓN
            if(this.state.operacion==='M'){
                data.valorAplicadoAnt = Math.round(this.state.valorApliO*100)/100;  //MONTO ORIGINAL APLICADO A COMPRA S
                data.valorTribAnt = Math.round(this.state.valorApliTribO*100)/100;  //MONTO ORIGINAL APLICADO A COMPRA P  
            }

            //ALWAYS SEND
            data.CompraAplicada = this.state.docPendientes_sel!==null?this.state.docPendientes_sel.Compra:null;

            if(this.state.controlAsignacion===true){
                data.valorAplicadoTributario = Math.round((parseFloat(this.state.total)-this.mostrarAsignacion())*100)/100; 
            }else{
                data.valorAplicadoTributario = Math.round(parseFloat(this.state.total)*100)/100;
            }

            //ENVIA COMPRA ANTERIOR EN CASO DE CAMBIAR DOC PRINCIPAL
            if(this.state.compraAnterior!==null){
                data.CompraAntP = this.state.compraAnterior===this.state.compra?null:this.state.compraAnterior;
            }

            let config_request = {
                method: this.state.operacion==='G'?'POST':'PATCH',
                url: this.state.operacion==='G'?'/creditoproveedores':'/creditoproveedores/'+this.state.notaCredito,
                data
            }
            console.log("ENVIO: ",data)
            global_axios(config_request)
            .then((response)=> {
                console.log("RESPUESTA: ",console.log("ENVIO: ",data))
                alert(response.data.msg);
                this.setState({ult_transaccion: response.data.transaction, num_diario: response.data.conMovimiento})
                this.clear();
            })
            .catch((error)=>{                
                alert(error.response?error.response.data.msg:error.message);  
            });
        }else{
            alert(errors);
        }
    }

    anularCredito(){
        var errors = "";
        var proceder = true;

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        if(proceder === false){
            alert(errors);
        }

        if(proceder === true){            
            //var total = parseFloat(this.state.total)

            global_axios({
                url: '/creditoproveedores/'+this.state.notaCredito,
                method: 'DELETE',
                headers: {'idregaudit': this.props.IdRegAudit},
              })
              .then((response)=>{
                alert(response.data.msg);
                this.clear();
              })
              .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);
            });
        }
    }

    clear(){
        //FECHA DE PROCESO POR MODULO
        let fechaProceso = getFechaProcesoPorModulo('06');

        this.setState({cod_proveedor: null, fechaProceso: moment(fechaProceso, 'DD/MM/YYYY'), fecha_nc: null})
        this.setState({valor: 0, observaciones: "", compra: "----------", saldo: 0,
        num_doc_serieNC: "", num_docNC: "", concepto_sel: null, tipoCompra_sel: null, iva: 0, total: 0,

        controlAsignacion: false, compraAsignada: "", saldoAsignado: 0, counterMsj: 0, opt_docPendientes: [],
        docPendientes_sel: null, opt_docsCargados: [], docsCargados_sel: null, saldoSuperiorCA: false,
        counterMsjCA: 0, compraAnterior: null, valorApliTributario: null,
        CompraApliAnt: null, valorApliTribO: null, autorizacion:"",
        valorApliO: null})

        this.setState({operacion: 'G', compraAnterior:null, valorAnterior: 0}) 
        //ope_NC_sel: 'NC'
    } 

    componentDidMount(){ 
        Promise.all([
            this.cargarObjetos('/secuenciales/CreditoProveedor'),
            cargarCatalogos_Otros('COM-NCCONCEP'), cargarCatalogos_Otros('COM-TIPCOMP'),
            cargarCatalogos_Otros('GEN-PLANVIG'), this.cargarCatalogos_OtrosParametros('COM-NCRUBROSCAT'),
            this.props.generar_LogAuditoriaIngresoForm('0603'),
        ])
        .then(([secCredito, result_conceptos, resultTipoCompra, r_planVigente, catRubrosPorCuenta]) => {

            //FECHA DE PROCESO POR MODULO
            let fechaProceso = getFechaProcesoPorModulo('06');

            this.setState({ ult_transaccion: completar_String(secCredito.codigo -1, '0', 6), opt_concepto: result_conceptos, 
            opt_tipoCompra: resultTipoCompra, planVigente: r_planVigente[0].value, catalogoCuentasPorRubro: catRubrosPorCuenta,
            permiso: this.props.permiso, fechaProceso: moment(fechaProceso,'DD/MM/YYYY'),
            fecha_nc: null})
        })
        .catch(()=>{
            alert('Parametros de sistema no han sido cargados.')
        }) 
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0603');
    }

    //Funciones que se ejecutan por cada setState
    componentDidUpdate(prevState){

        //Controla el cuadro de dialogo sobre la validacion del total VS Saldo NC
        if(this.state.controlAsignacion===true && this.state.ope_NC_sel==='NC' && this.state.carga===false){
            if(this.state.counterMsj===0)
            this.setState ({counterMsj: 1},()=>{
                if(this.state.operacion==='G'){
                    var msj = window.confirm("El total supera al saldo de la compra, ¿Continuar?");
                    if(!msj){
                        this.setState({valor: 0, iva: 0, controlAsignacion: false})
                    } 
                }
            }) 
        }

        //Controla el cuadro de dialogo sobre la validacion del total VS Saldo CA
        if(this.state.saldoSuperiorCA===true && this.state.ope_NC_sel==='CA'){
            if(this.state.counterMsjCA===0)
            this.setState ({counterMsjCA: 1},()=>{
                let saldo = parseFloat(this.state.total)-parseFloat(this.state.saldo)
                alert(`El monto del crédito es superior al saldo de la compra: ${this.state.compra} con ${Math.round(saldo*100)/100}`)
            }) 
        }
    }

    //Funcion que trae documentos segun proveedor y tipo de doc 
    getProveedor(){
        if(this.state.cod_proveedor !== null && this.state.tipoCompra_sel!==null){
            var cuenta = "";
            console.log("DOC: ", this.state.tipoCompra_sel)
            console.log("PROV: ",this.state.cod_proveedor.value)

            this.cargarObjetos('/proveedores?tipo=indt_proveedor&ident='+this.state.cod_proveedor.value).then((result)=>{
                if(result.length > 0){
                    this.setState({nombreProveedor: result[0].Descripcion,
                    cuenta: (result[0].Tipo==='S')?result[0].CuentaContableServicio:result[0].Cuenta})
                    cuenta = (result[0].Tipo==='S')?result[0].CuentaContableServicio:result[0].Cuenta;//OK
                    
                    if(cuenta === null || cuenta === ""){
                        alert("El Proveedor seleccionado no posee cuenta, antes de continuar edite el proveedor y asignele una cuenta")
                        this.clear();
                    }else{
                        this.cargarCuentasContables(cuenta.toString().trim(),this.state.planVigente).then((r_ctaContable)=>{
                            if(r_ctaContable===null){
                                this.setState({cuentaContable: null})
                                alert("La cuenta contable no se encuentra registrada en el plan: "+this.state.planVigente);
                            }else{
                                //TRAE LOS DOCUMENTOS SOLICITADOS DESDE COMPRAS (VALIDACIÓN OK)

                                //TRAE DOCS PENDIENTES DE PAGO
                                this.cargarObjetos('/compras?proveedor='+result[0].Codigo+'&tipo='+this.state.tipoCompra_sel+'&status=P&status=E').then((result_docs)=>{
                            
                                    console.log("RESULT DOCS: ",result_docs)
                                    var arrayDocs = [], docsProcesados = [];
                                    
                                    arrayDocs = result_docs;
                                    if(arrayDocs.length>0){
                                        let arrayPendiente = [];
                                        arrayDocs.forEach((DATA)=>{
                                            let item = {};
                                            let str = "";
                                            str = DATA.Establecimiento.toString().trim()+''+DATA.PuntoVenta.toString().trim()+'-'+DATA.Factura.toString().trim()
                                            item.value = DATA.Compra
                                            item.label = str
                                            item.Saldo = DATA.Saldo;
                                            item.Importe = DATA.Importe;
                                            item.Compra = DATA.Compra;

                                            //ArrayDocsPendientes+Cancelados
                                            docsProcesados.push(item);
                                            
                                            //ArrayDocsPendientes
                                            arrayPendiente.push(item);
                                        })
                                        
                                        //guarda solo docs pendientes en state provisional
                                        this.setState({opt_docPendientes: arrayPendiente })
                                    }else{
                                        alert("El proveedor no tiene documentos pendientes")
                                    }

                                    if(this.state.ope_NC_sel==='NC'){
                                        //TRAE TOP 5 DE DOCS CANCELADOS
                                        this.cargarObjetos('/compras?proveedor='+result[0].Codigo+'&tipo='+this.state.tipoCompra_sel+'&status=C&top=5&order=DESC').then((resultC)=>{
                                            if(resultC.length >0){

                                                //INSERT DE SEPARADOR EN REACTSELECT
                                                let itemS = {};
                                                itemS.label = "== CANCELADAS ==";
                                                itemS.value = '===';
                                                itemS.disabled=true;
                                                docsProcesados.push(itemS);

                                                resultC.forEach((CANCEL)=>{
                                                    let item = {};
                                                    let str = "";
                                                    str = CANCEL.Establecimiento.toString().trim()+''+CANCEL.PuntoVenta.toString().trim()+'-'+CANCEL.Factura.toString().trim()
                                                    item.value = CANCEL.Compra
                                                    item.label = str
                                                    item.Saldo = CANCEL.Saldo;
                                                    item.Importe = CANCEL.Importe;
                                                    item.Compra = CANCEL.Compra;

                                                    docsProcesados.push(item);
                                                })
                                            }
                                            
                                        })
                                    }
                                    this.setState({opt_docsCargados: docsProcesados, cuentaContable: r_ctaContable.Cuenta})
                                })
                            }
                        })
                    }
                }else{
                    this.setState({cod_proveedor:null}, ()=>{
                        if(result.length <= 0 && this.state.cod_proveedor===null){
                            alert('No existen coincidencias con el número de cédula ingresado');
                        }
                    })
                }
            })
        }
    }

    cargarCuentasContables(cuenta, plan){
        return new Promise((resolve, reject) => {
            //CUENTA + PLANVIGENTE
            global_axios.get('/cuentas/'+cuenta+'/'+plan)
            .then((response)=>{                
                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }

    selCompra(){
        if(this.state.docsCargados_sel!==null){
            this.setState({compra: this.state.docsCargados_sel.Compra, 
                saldo: this.state.docsCargados_sel.Saldo},()=>{
                    console.log("COMPRA: ", this.state.docsCargados_sel.Compra)
                    console.log("SALDO: ", this.state.docsCargados_sel.Saldo)
                    this.totalizar();
                })
        }
    }

    selCompraAsignada(){
        if(this.state.docPendientes_sel!==null){
            console.log("total: ",parseFloat(this.state.total), "saldo: ",parseFloat(this.state.saldo))
            let totalAsig = (parseFloat(this.state.total) - parseFloat(this.state.saldo))
            this.setState({compraAsignada: this.state.docPendientes_sel.Compra, 
            saldoAsignado: this.state.docPendientes_sel.Saldo },()=>{
                if(this.state.operacion==='G'){
                    this.setState({labelAplicado: Math.round(totalAsig*100)/100})
                }
            })
        }
    }

    changeProveedor(value){

        if(value!==null){
            this.setState({cod_proveedor: value, docsCargados_sel: null,opt_docsCargados: [] })
        }else{
            this.setState({cod_proveedor: null, docsCargados_sel: null,opt_docsCargados: [] })
        }
    }

    //Evento sobre onChange Serie/Factura
    changeDocument(value){
        console.log("SELECCION DOC: ",value)
        if(value!==null){
            console.log("VALOR DEL CLICK AP: ", value);
            this.setState({docsCargados_sel: value, docPendientes_sel:null, saldoAsignado: null},()=>{
                if(this.state.operacion==='G'){
                    this.setState({labelAplicado: null, compraAsignada: null})
                }
                //CARGA AUTOMATICA DE SU CONTRAPARTE
                if(this.state.operacion === 'M' && this.state.carga === false){
                    if(this.state.opt_docPendientes.length > 0){
                        this.state.opt_docPendientes.forEach((PEN)=>{
                            console.log("PEN COMPRA: ",PEN.Compra, " COMPRA ASIG: ",this.state.compraAsignada )
                            if(PEN.Compra === this.state.compraAsignada && this.state.compraAnterior === this.state.docsCargados_sel.Compra ){
                                this.setState({docPendientes_sel: PEN},()=>{
                                    this.selCompraAsignada();
                                });
                            }
                        })
                    }
                }
            })
            this.ActivaDesactivaListaDocs(this.state.opt_docPendientes, value, true);
        }else{
            console.log("VALOR DEL CLICK RP: ", value);
            let valor = this.state.docsCargados_sel.label;
            if(valor!==null){
                this.ActivaDesactivaListaDocs(this.state.opt_docPendientes, valor, false);
            }
            this.setState({docsCargados_sel: null, docPendientes_sel:null});
        }
    }

    //Evento sobre onChange Serie/Factura Ptes.
    changeDocumentPentientes(value){
        if(value!==null){
            this.setState({docPendientes_sel: value});
        }else{
            this.setState({docPendientes_sel: value, compraAsignada: "", saldoAsignado: ""});
        }
    }

    //Evento sobre onChange Operacion
    changeOperacion(value){
        
        console.log("OPT: ", this.state.opt_ope_NC)
        if(value!==null){
            console.log("OP: ",value.value)
            this.setState({ope_NC_sel: value.value})
        }else{
            this.setState({ope_NC_sel: null})
        }
        this.clear();
    }

    //Activa/Desactiva el documento ya seleccionado
    ActivaDesactivaListaDocs(array, value, bool){
        array.forEach(function(OPT){
            if(OPT.hasOwnProperty('disabled')===true){
                delete OPT.disabled;
            }
            if(OPT.label === value.label){
                OPT.disabled = bool;
            }
        })
    }

    //Cambia el # de serie de la NC
    changeNumSerie(event){
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value;        
        if(value.length <=6){
            if(isNaN(value)===false){
                this.setState({            
                    [name]: value
                    });
            }
        } 
    }

    //Cambia el # de factura de la NC
    changeNumFactura(event){    
        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        if(value.length <=9){
            if(isNaN(value)===false){
                this.setState({            
                    [name]: value
                    });
            }
            
        }   
    }

    //Valida SERIE NC
    validNumSerieNC(event){        
        var numSerie = this.state.num_doc_serieNC.toString();
        var establecimieto = this.state.num_doc_serieNC.toString().substr(0,3);
        var serie = this.state.num_doc_serieNC.toString().substr(3,5);

        var e = establecimieto.substr(2,2);
        var s = serie.substr(2,2);
        if(numSerie.length === 6){
            if(parseInt(e,10) === 0 || parseInt(s,10) === 0){                
                this.setState({num_doc_serieNC: ''});
            }
        }else{            
            this.setState({num_doc_serieNC: ''});            
        }   
    }

    mostrarAsignacion(){
        var result = 0;

        if(this.state.docsCargados_sel!==null){
            //console.log("labelAplicado: ",this.state.labelAplicado)
            if(this.state.docsCargados_sel.Compra===this.state.compraAnterior && this.state.valorAnterior === this.state.total){
                result = this.state.labelAplicado//!==null?Math.round(this.state.labelAplicado*100)/100:(Math.round((this.state.total-this.state.saldo)*100)/100)
            }else{
                if(this.state.compraAnterior === this.state.docsCargados_sel.Compra){
                    console.log("ENTRO AQUI")
                    result = Math.round((this.state.total-this.state.valorApliTributario)*100)/100;
                }else{
                    console.log("ENTRO ACA COMPRA ANT: ", this.state.compraAnterior, "SEL COMPRA: ",this.state.docsCargados_sel.Compra)
                    result = Math.round((this.state.total-this.state.saldo)*100)/100;
                }
            }
        }
        return result;
    }

    seleccionCuentaPorRubro(value){
        if(value){
            console.log('VALUE: ', value)
            this.setState({concepto_sel: value.value})

            let cuentaLabel = '';
            let descripcionLabel = '';

            console.log('CAT RUBRO: ', this.state.catalogoCuentasPorRubro)

            this.state.catalogoCuentasPorRubro.forEach((CTAS)=>{
                if(CTAS.Codigo === value.value){
                    cuentaLabel = CTAS.Nombre
                    descripcionLabel = CTAS.Referencia
                }
            })

            this.setState({cuentaLabel, descripcionLabel})
        }else{
            this.setState({concepto_sel: ""})
        }
    }

    cargarCatalogos_OtrosParametros(tipo) {
        return new Promise((resolve, reject) => {
            global_axios.get('/catalogos?tipo=otros&opcion=' + tipo)
            .then((response)=>{

                resolve(response.data);
            })
            .catch((err)=>{
                reject('Error al cargar datos de catálogos desde API: ' + err);
            });
        });
    }
    
    render(){
        const invisible = {display: 'none'};
        const visible = {display: 'block'};
        return(
            <ContenedorForm porc_ancho={80}>
             <HeaderForm>
                <TituloForm>Crédito de proveedores</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario.: {this.state.num_diario}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit>
                        <Row>
                            <ContainerCol className='col-md-1'>
                                <LabelForm>NC: </LabelForm>
                            </ContainerCol>                           
                            <ContainerCol className='col-md-3'>                                
                                <div className='input-group'>
                                    <InputText2 name='notaCredito' value={this.state.notaCredito} type="number" className='form-control input-sm' onChange={this.changeNotaCredito} onBlur={this.setOperacion}/>
                                    <span className='input-group-addon addon-busq-especif'><button type="button" className='btn btn-default medida-button-busq-especif' onClick={this.getNotaCredito}><i className="fa fa-check-circle-o"></i> Seleccionar</button></span>
                                </div>
                            </ContainerCol>                        
                            <ContainerCol className='col-md-2 col-md-push-5'>
                                <LabelForm>Fecha:</LabelForm>
                            </ContainerCol>
                            

                            <ContainerCol className='col-md-2 col-md-offset-4'>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Operación:</LabelForm>
                            <ReactSelect options={ this.state.opt_ope_NC } value={this.state.ope_NC_sel} func_onChange={(value)=>{this.changeOperacion(value)}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-4'>
                            <LabelForm>Proveedor:</LabelForm>
                            <ReactSelectAsync value={this.state.cod_proveedor} disabled={this.state.operacion === 'G'?false:true} func_loadOptions={this.getOptions_Proveedores} func_onChange={(value)=>{this.changeProveedor(value)}}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Tipo doc.:</LabelForm>
                            <ReactSelect options={ this.state.opt_tipoCompra } value={this.state.tipoCompra_sel} func_onChange={(value)=>{this.setState({tipoCompra_sel: (value!==null?value.value:null)})}} func_onBlur={(value)=>{this.getProveedor(value)}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Serie/Factura</LabelForm>
                            <ReactSelect disabled={this.state.opt_docsCargados.length >0?false:true} options={ this.state.opt_docsCargados } value={this.state.docsCargados_sel} func_onChange={(value)=>{this.changeDocument(value)}}
                            func_onBlur={this.selCompra}/>
                        </ContainerCol>                        
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Compra:</LabelForm>
                            <LabelForm>{this.state.compra}</LabelForm>                             
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Saldo</LabelForm>
                            {this.state.saldo<0.1?<br/>:''}
                            <LabelForm>${Math.round((this.state.saldo) * 100)/ 100}</LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-md-3'>
                            <LabelForm>Rubro:</LabelForm>
                            <ReactSelect options={ this.state.opt_concepto } disabled={this.state.compra!=="----------"?false:true} value={this.state.concepto_sel} func_onChange={(value)=>{this.seleccionCuentaPorRubro(value)}}  /*func_onChange={(value)=>{this.setState({concepto_sel: value!==null?value.value:""})}}*//>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Valor:</LabelForm>
                            <InputText name='valor' value={this.state.valor} disabled={this.state.compra!=="----------"?false:true} type="number" className='form-control input-sm' onChange={this.changeValueGeneral} onBlur={this.validacionValor}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Iva:</LabelForm>
                            <InputText name='iva' value={this.state.iva}  disabled={this.state.compra!=="----------"?false:true} type="number" className='form-control input-sm' onChange={this.changeValueGeneral} onBlur={this.totalizar} autocomplete="off"/>
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Total:</LabelForm>
                            {this.state.total===0?<br/>:''}
                            <LabelForm>${this.state.total}</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-md-2' style={this.state.ope_NC_sel === 'NC'?visible:invisible}>
                            <LabelForm>N° N/C Cliente:</LabelForm>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"></span>
                                </div>
                                <InputText2 className='input-sm' type="text" name='num_doc_serieNC' autoComplete='off' value={this.state.num_doc_serieNC} onChange={this.changeNumSerie} onBlur={this.validNumSerieNC} disabled={this.state.compra!=="----------"?false:true}/>
                                <InputText2 className='input-sm' type="text" name='num_docNC' autoComplete='off' value={this.state.num_docNC}  onChange={this.changeNumFactura} disabled={this.state.compra!=="----------"?false:true}/>
                            </div>
                        </ContainerCol>
                        <ContainerCol className='col-md-2' style={this.state.ope_NC_sel === 'NC'?visible:invisible}>
                            <LabelForm>Fecha N/C.:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fecha_nc} func_onChange={(fechaEscogida)=>{this.setState({fecha_nc: fechaEscogida})}} disabled={this.state.compra!=="----------"?false:true}/>
                        </ContainerCol>
                    </Row>
                    
                    <Row>
                        <ContainerCol className='col-md-12'>
                        <LabelForm color='green'>Cuenta: {this.state.cuentaLabel} - Descripcion: {this.state.descripcionLabel}</LabelForm>
                        </ContainerCol>
                    </Row>
                    
                    <Row>                        
                        <ContainerCol className='col-md-12'>
                            <LabelForm>Observaciones:</LabelForm>
                            <InputText name='observaciones' mayusculas="true" value={this.state.observaciones} type="text" className='form-control input-sm' autoComplete='off' onChange={this.changeValueGeneral}/>
                        </ContainerCol>
                    </Row>
                    <Row isInvisible={this.state.controlAsignacion===true?false:true} margen_arriba="4">
                        <ContainerCol className='col-md-2'>
                            <LabelForm>Serie/Factura Ptes.:</LabelForm>
                            <ReactSelect disabled={this.state.opt_docPendientes.length >0?false:true} options={ this.state.opt_docPendientes } value={this.state.docPendientes_sel} func_onChange={(value)=>{this.changeDocumentPentientes(value)}}
                            func_onBlur={this.selCompraAsignada}/>
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Compra Asig.:</LabelForm>
                            <LabelForm>{this.state.compraAsignada}</LabelForm>                             
                        </ContainerCol>
                        <ContainerCol className='col-md-1'>
                            <LabelForm>Saldo Asig.:</LabelForm>
                            <LabelForm>${Math.round(this.state.saldoAsignado*100)/100}</LabelForm>                                
                        </ContainerCol>
                        <ContainerCol className='col-md-1 col-md-offset-7 col-md-pull-7'>
                            <LabelForm>Saldo Apli.:</LabelForm>
                            <LabelCabecera alineacion="center" derecha="0" color={(Math.round(this.state.saldoAsignado*100)/100)>(Math.round((this.state.total-this.state.saldo)*100)/100)?'green':'red'}>${this.mostrarAsignacion()}</LabelCabecera>                             
                        </ContainerCol>
                    </Row>
                    <Row>                        
                        <ContainerCol className='col-md-6'  style={this.state.ope_NC_sel === 'NC'?visible:invisible}>
                            <LabelForm>N. Autorizacion:</LabelForm>
                            <InputText name='autorizacion' value={this.state.autorizacion} type="text" className='form-control input-sm' autoComplete='off' onChange={this.changeValueGeneral}/>
                        </ContainerCol>
                    </Row>

                    <Row>         
                        <br/> 
                        <div className='col-md-12'>
                            <div className="btn-group pull-right">
                            <button type="submit" className='btn btn-primary btn-sm' onClick={this.guardarCredito}>
                                <i className="fa fa-floppy-o fa-lg"></i> Guardar
                            </button>
                            <button type="submit" className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularCredito}>
                                <i className="fa fa-ban fa-lg"></i> Anular
                            </button>
                            <button type="button" className='btn btn-sm' onClick={this.clear}>
                                <i className="fa fa-trash-o fa-lg"></i> Limpiar
                            </button>
                            </div>
                        </div>                  
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}
const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
        diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormComp03);